import { type FC } from "react";
import { trackHeader as track } from "~/events";
import { Logo } from "~/icons";
import { MessageNavItem } from "./MessageNavItem";

const { VITE_GENERIC_SMS_PHONE_NUMBER } = import.meta.env;

export const MessageConceiveNavItem: FC = () => {
  const link = `sms:${VITE_GENERIC_SMS_PHONE_NUMBER}`;

  return (
    <MessageNavItem
      left={<Logo color="th.black" mr={2} />}
      link={link}
      onClick={track.messageConceive}
      who="conceive"
    />
  );
};
